class ModalDialog extends HTMLElement {
    constructor() {
        super();

        this.querySelector('.ml_popup_overlay')?.addEventListener('click', this.hide.bind(this), { passive: true })
        this.querySelector('[id^="ModalClose-"]')?.addEventListener(
            'click',
            this.hide.bind(this),
            { passive: true }
        );
        document.addEventListener('keyup', (event) => {
            if (event?.code?.toUpperCase?.() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            }, { passive: true });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
            }, { passive: true });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        setTimeout(() => {
            this.querySelector('#hiddenInput')?.focus()
            this.querySelector('#Search-In-Modal')?.focus()
        }, 100);
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const button = this.querySelector(`button${this.dataset.extraSelector ? `.${this.dataset.extraSelector}` : ''}`);

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        }, { passive: true });
    }
}
customElements.define('modal-opener', ModalOpener);